import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { verifyResetOtpApi, forgotPasswordApi, toAuthResult } from "@/portals/patient/api/patientAuthApi";
import { OtpPanel } from "./OtpPanel";
import { getAuthFlowState, clearAuthFlowState } from "./authFlowState";

interface VerifyResetOtpState {
  email: string;
}

export function VerifyResetOtpPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const routeState = location.state as VerifyResetOtpState | null;
  const email = routeState?.email ?? getAuthFlowState()?.email ?? null;

  if (!email) {
    return <Navigate to="/patient/auth/forgot-password" replace />;
  }

  const handleVerified = (_otp: string, resetToken?: string) => {
    clearAuthFlowState();
    navigate("/patient/auth/reset-password", { replace: true, state: { email, resetToken } });
  };

  return (
    <OtpPanel
      email={email}
      title={<>Email <span className="font-extrabold tracking-tight">verification</span></>}
      subtitle="Verify your email to reset your password."
      onVerify={(otp) =>
        verifyResetOtpApi(email, otp).then((res) => ({
          ...toAuthResult(res),
          resetToken: res.data?.resetToken,
        }))
      }
      onResend={() => forgotPasswordApi(email).then(toAuthResult)}
      onVerified={handleVerified}
    />
  );
}
